import React from 'react';
import ReactDOM from 'react-dom';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import PropTypes from 'prop-types';
import Moment from 'moment';
import $ from 'jquery';

import './Calendar.css';

var I18n = require('i18n-react').default;

const dayLabels = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
const monthLabels = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
];

const defaultProps = {
  dateFormat: 'DD/MM/YYYY'
};

const propTypes = {
  dateFormat: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any
};

class Calendar extends React.Component {
  constructor() {
    super();

    this.calendarIconOnClick = this.calendarIconOnClick.bind(this);
    this.calendarIconOnMouseOver = this.calendarIconOnMouseOver.bind(this);
    this.calendarIconOnMouseOut = this.calendarIconOnMouseOut.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const component = ReactDOM.findDOMNode(this.refs[this.props.id].refs.input);
    component.addEventListener('change', event => {
      const value = event.target.value;
      if (!value || value.length === 0 || !Moment(value, _this.props.dateFormat).isValid()) {
        _this.props.onChange('');
      }
    });

    component.addEventListener('focus', event => {
      component.placeholder = I18n.translate('components.calendar.focusPlaceholder');
    });
  }

  calendarIconOnMouseOver() {
    ReactDOM.findDOMNode(this.refs[this.props.id].refs.input).classList.add('selected');
  }

  calendarIconOnMouseOut() {
    ReactDOM.findDOMNode(this.refs[this.props.id].refs.input).classList.remove('selected');
  }

  calendarIconOnClick() {
    const calendarInput = $(`#componentCalendar-${this.props.id} :text`);
    const calendarPopover = $(`#${this.props.id}_group #date-picker-popover-0`);

    if (calendarPopover.length === 0) {
      calendarInput.focus();
    } else {
      calendarInput.blur();
    }
  }

  render() {
    return (
      <div id={`componentCalendar-${this.props.id}`} className="componentCalendar">
        <span
          className="azul-calendar-icon"
          onMouseOver={this.calendarIconOnMouseOver}
          onMouseOut={this.calendarIconOnMouseOut}
          onClick={this.calendarIconOnClick}
        />
        <Row>
          <Col>
            <ControlLabel>{this.props.title}</ControlLabel>
          </Col>
        </Row>
        <Row>
          <Col>
            <DatePicker
              id={this.props.id}
              className="data-hj-whitelist"
              placeholder={this.props.placeholder}
              dateFormat={this.props.dateFormat}
              minDate={this.props.minDate}
              maxDate={this.props.maxDate}
              onFocus={this.props.onFocus}
              onChange={(event, value) => {
                const date = Moment(value, this.props.dateFormat).toISOString();
                this.props.onChange(date);
              }}
              value={this.props.value}
              ref={this.props.id}
              previousButtonElement={' '}
              nextButtonElement={' '}
              showClearButton={false}
              dayLabels={dayLabels.map(key =>
                I18n.translate(`components.calendar.dayLabels.${key}`)
              )}
              monthLabels={monthLabels.map(key =>
                I18n.translate(`components.calendar.monthLabels.${key}`)
              )}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

Calendar.defaultProps = defaultProps;
Calendar.propTypes = propTypes;

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/searchBox/calendar/Calendar.jsx